import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as R from 'ramda';

import {
  GET_USER_DETAILS,
  UPDATE_USER_BASIC_META,
  SET_PERMISSIONS,
  SET_LOCATION,
  DELETE_USER,
  UPDATE_USER_DATA,
  FETCH_BASIC_USERS,
  CREATE_USER
} from '../../store/constants';

import {
  doGetUserDetailsSuccess,
  doGetUserDetailsError,
  doUpdateBasicUserMetaError,
  doUpdateBasicUserMetaSuccess,
  doSetPermissionsSuccess,
  doSetPermissionsError,
  doDeleteUserSuccess,
  doDeleteUserError,
  doUpdateUserDataSuccess,
  doUpdateUserDataError,
  doFetchBasicUsersSuccess,
  doFetchBasicUsersError,
  doCreateUserSuccess, 
  doCreateUserError,
} from '../../actions/user';

import { doShowMessage } from '../../actions/message';

import { getUserDetails, updateUserMeta, postPermissions, deleteUser, updateUserData, fetchBasicUsers, createUserData } from '../starbookApiCalls';

import { postWorker } from './../helpers/post-worker';

const { ifElse } = R;

const apiCallObject = ifElse(
  (admin) => admin.adminViewAvailable,
  (data) => ({
    id: data.id,
    type: 'admin',
  }),
  (data) => ({
    id: data.id,
    type: 'details',
  }),
);

export function* getUserDetailsSaga(action) {
  try {
    const apiCallData = apiCallObject(action.payload);

    const result = yield call(getUserDetails, apiCallData);

    yield all([put(doGetUserDetailsSuccess(result.data))]);
  } catch (error) {
    console.log(error);
    yield all([
      put(doGetUserDetailsError(error)),
      put(
        doShowMessage({
          type: 'error',
          content: error.message,
        }),
      ),
    ]);
  }
}

export function* updateUserMetaSaga(action) {
  try {
    const result = yield call(updateUserMeta, action.payload);

    yield all([
      put(doUpdateBasicUserMetaSuccess(result.data)),
      put(
        doShowMessage({
          type: 'success',
          content: 'Successfully updated',
        }),
      ),
    ]);
  } catch (error) {
    yield all([
      put(doUpdateBasicUserMetaError(error)),
      put(
        doShowMessage({
          type: 'error',
          content: error.message,
        }),
      ),
    ]);
  }
}

function* setPermissions(action) {
  try {
    const { data } = yield call(postPermissions, action.payload);
    yield all([
      put(doSetPermissionsSuccess(data)),
      put(
        doShowMessage({
          type: 'success',
          content: 'Successfully updated',
        }),
      ),
    ]);
  } catch (error) {
    yield all([
      put(doSetPermissionsError(error)),
      put(
        doShowMessage({
          type: 'error',
          content: error.message,
        }),
      ),
    ]);
  }
}

function* deleteUserSaga(action) {
  try {
    yield call(deleteUser, action.payload);
    yield put(doDeleteUserSuccess());
  } catch (err) {
    yield put(doDeleteUserError(err.response?.data || err.message));
  }
}

function* updateUserDataSaga(action) {
  try {
    const response = yield call(updateUserData, action.payload);
    yield put(doUpdateUserDataSuccess(response.data));
  } catch (err) {
    yield put(doUpdateUserDataError(err.response?.data || err.message));
  }
}

function* createUserDataSaga(action) {
  try {
    const response = yield call(createUserData, action.payload);
    yield put(doCreateUserSuccess(response.data));
  } catch (err) {
    yield put(doCreateUserError(err.response?.data || err.message));
  }
}

function* fetchBasicUsersSaga() {
  try {
    const response = yield call(fetchBasicUsers);
    yield put(doFetchBasicUsersSuccess(response.data));
  } catch (err) {
    yield put(doFetchBasicUsersError(err.response?.data || err.message));
  }
}

export function* watchGetUserDetails() {
  yield takeLatest(GET_USER_DETAILS, getUserDetailsSaga);
}

export function* watchUpdateBasicUserMeta() {
  yield takeLatest(UPDATE_USER_BASIC_META, updateUserMetaSaga);
}

export function* watchSetPermissions() {
  yield takeLatest(SET_PERMISSIONS, setPermissions);
}

export function* watchSetLocation() {
  yield takeLatest(SET_LOCATION, postWorker);
}

export function* watchUser() {
  yield takeLatest(DELETE_USER, deleteUserSaga);
  yield takeLatest(UPDATE_USER_DATA, updateUserDataSaga);
  yield takeLatest(FETCH_BASIC_USERS, fetchBasicUsersSaga);
  yield takeLatest(CREATE_USER, createUserDataSaga);
}
